import { render, staticRenderFns } from "./CentralIconEl.vue?vue&type=template&id=a8150044&"
import script from "./CentralIconEl.vue?vue&type=script&lang=ts&"
export * from "./CentralIconEl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports